import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Catalog from './pages/Catalog';
import PhoneDetail from './pages/PhoneDetail';
import Admin from './pages/Admin';
import UserManagement from './pages/UserManagement';
import MyBids from './pages/MyBids';
import BidsReport from './pages/BidsReport';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Catalog />} />
          <Route path="/phone/:id" element={<PhoneDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/my-bids" element={<MyBids />} />
          <Route path="/bids-report" element={<BidsReport />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
